// 本地数据存储的key
const SESSION_KEY = 'XITO_USER_IFON';

class MyConfig {
    constructor() {
        // 获取基础数据
        this.changeUrlParam();
        // 开启监听路由变化
        this.listenerRouter();
    }
    findConfig(path = './config.js') {
		return new Promise(resolve => {
			this.getFileData(path).then(res => {
				let result = null;
				if (res.status === 'success' && Array.isArray(res.data)) {
					// HREF 	https://xxx.xxx.com/home?status=1
					// URL  	https://xxx.xxx.com/home
					// ORIGIN 	https://xxx.xxx.com
					// HOST 	xxx.xxx.com
					// SEARCH 	?status=1
					const { URL, HOST, HREF, SEARCH, ORIGIN } = this;
					// 优先匹配有roomDomain，将有roomDomain放置在数组前面
					res.data = res.data.sort((a, b) => {
						if ((b['roomDomain'] && a['roomDomain']) || (a['roomDomain'] === b['roomDomain'])) {
							return 0;
						}
						if (b['roomDomain']) {
							return 1;
						}
						return -1;
					});
					result = res.data.find(item => {
						if (item['roomDomain']) {
							return (item['roomDomain'] === HOST) && (item['domainOrigin'] === SEARCH);
						} else {
							return (item['domainOrigin'] === SEARCH);
						}
						return false;
					}) || null;
					// console.log(res.data, result)
				}
				resolve(result);
			});
		});
	}
	getFileData(filePath = '', defaultData = []) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', filePath, true);
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        let data = xhr.responseText;
                        try {
                        	data = JSON.parse(xhr.responseText);
                        } catch(err) {
                            data = xhr.responseText;
                            // 如果是.js文件
                            if (filePath.substring(filePath.length - 3) === '.js') {
                                data = data.replace('export default', '');
                                data = eval(data) || defaultData;
                            }
                        }
                        resolve({
                            status: 'success',
                            data: data || defaultData
                        });
                    } else {
                        reject();
                    }
                }
            }
            xhr.send(null);
        });
    }
    changeUrlParam() {
        // 网址分解
        const { host, href, origin, search, pathname } = window.location;
        // 网址主机
        this['HOST'] = host;
        // 网址全称
        this['HREF'] = href;
        // 网址源头
        this['ORIGIN'] = origin;
        // 网址搜索参数
        this['SEARCH'] = href.indexOf('?') > -1 ? href.substring(href.indexOf('?')) : '';
        // 网址去掉参数
        this['URL'] = href.replace(this['SEARCH'], '');
        // 网址参数
        this['QUERY'] = Object.create(null);
        // 生成对象模式
        if (href.indexOf('?') > -1) {
            // for (let [ key, value ] of search.substring(search.indexOf('?') + 1).split('&').filter(Boolean).map(v => v.split('=').filter(Boolean)) ) {
            // for (let [ key, value ] of hash.substring(hash.indexOf('?') + 1).split('&').filter(Boolean).map(v => v.split('=').filter(Boolean)) ) {
            for (let [ key, value ] of href.substring(href.indexOf('?') + 1).split('&').filter(Boolean).map(v => v.split('=').filter(Boolean)) ) {
                if (key) {
                    this['QUERY'][ key ] = value || '';
                }
            }
        }
    }
    listenerRouter() {
        function historyWrap () {
            // 重写pushState、replaceState方法使其能够触发监听事件
            const rewriteMethod = function(type) {
                const originMethod = window.history[type];
                const typeEvent = new Event(type);
                return function() {
                    const newMethod = originMethod.apply(this, arguments);
                    typeEvent.arguments = arguments;
                    window.dispatchEvent(typeEvent);
                    return newMethod;
                };
            };
            // 在重写的方法中添加监听事件
            window.history['pushState'] = rewriteMethod('pushState');
            window.history['replaceState'] = rewriteMethod('replaceState');
            // 对监听事件统一触发historychange事件
            const dispatchEventHistoryChange = function(event) {
                // 1
                const historyChangeEvent = new Event('historychange');
                historyChangeEvent.arguments = arguments;
                window.dispatchEvent(historyChangeEvent);
                // // 2
                // event['type'] = 'historychange';
                // window.dispatchEvent(event);
            };
            window.addEventListener('popstate', dispatchEventHistoryChange);
            window.addEventListener('pushState', dispatchEventHistoryChange);
            window.addEventListener('replaceState', dispatchEventHistoryChange);
        }
        historyWrap();
        const onEventMethod = this.changeUrlParam.bind(this);
        // 页面初始化
        window.addEventListener('load', onEventMethod);
        // 监听hash路由
        window.addEventListener('hashchange', onEventMethod);
        // 监听history路由(自定义historychange事件)
        window.addEventListener('historychange', onEventMethod);
    }
    async extendConfig() {
        const { URL, HOST, HREF, QUERY, SEARCH, ORIGIN } = this;
        const extendConfig = Object.create(null);
        const regionList = ['east', 'west'];
        /****** 多个项目中均可用到的一些配置 ******/
        
        // 软件id(识别桌面/移动设备)
        const APP_ID = 'eb4dd4e5488df8d37d0d0f3b013556e8';
        // 东区接口
        const EAST_API = 'https://appinterface.xitohere.com';
        // 西区接口
        const WEST_API = 'https://uappitfc1.xitohere.com';
        // 东区token
        const EAST_ACCESS_TOKEN = 'MDAwMDAwMDAwMISMpty1pd3avXaqsLJ4wM29hY6fhn6zaYB5hJ2JiaLNj4yz0LSpt92xnLOjsXWz37GEr6qIe8Vtf3ahqX2vodo';
        // 西区token
        const WEST_ACCESS_TOKEN = 'MDAwMDAwMDAwMIOMppiyqb-XvZ-vnr2It92ydX6ciIu4pX55g2N9n3zMhI-7z8CmuMyxZK-espu3lbB1fWWHsaNof6yZZn55h58';
        // 支付密钥
        // pro pk_live_dbfBnEidvsBfJfUkY0V0wiy1002ZNHJeox
        // dev pk_test_7hSrFkHddebKkQNu6bZAvLez00NWJPaqqj
        const STRIPE_KEY = process.env.NODE_ENV === 'production' ? 'pk_live_dbfBnEidvsBfJfUkY0V0wiy1002ZNHJeox' : 'pk_test_7hSrFkHddebKkQNu6bZAvLez00NWJPaqqj';
        
        /****** 只有本项目中可用到的一些配置 ******/
        
        // // 本地数据存储的key(必须跟userInfo.js文件的存储的key一致)
        // const SESSION_KEY = 'XITO_USER_IFON';
        
        // 口令、邮箱弹窗中是否要验证手机号码
        const VERIFY_MOBILE = false;

        // video官网主页面是否需要登录
        const XITO_NEED_LOGIN = false;

        // 官网主页面的库phamula_id
        const XITO_LIBRARY_ID = '1998'; // 1520 1324

        // 官网主页面的库phamula_id
        const XITO_JSON_FILE = '404.o';

        /*
            1 https://panvr.xitohere.com/pagetest => 显示默认的页面
            2 https://panvr.xitohere.com/pagetest?xxx => 匹配到config.js的数据
            3 https://panvr.xitohere.com/pagetest?p_id=1234 => 显示官网主页面phamula_id为1234的数据
            4 https://panvr.xitohere.com/pagetest?p_id=xito => 显示官网主页面文件为xito.o的数据
        */

        // 查找配置(如果当前网址包含了某一个给定的路由地址)
        let config_result = await this.findConfig();
		
        // east东区 west西区
        extendConfig['region'] = 'east';
        // 要拉取的文件名称
        extendConfig['jsonFile'] = '';
        // 要加载的phamula_id
        extendConfig['libraryId'] = '';
        
        if (URL.indexOf('https://panvr.xitohere.com/pagetest') > -1) {
            extendConfig['region'] = 'east';
        }
        
        if (URL.indexOf('https://musee.xitotech.com/fair') > -1) {
            extendConfig['region'] = 'west';
        }
		
        // 根据找到的配置替换当前配置?xxxx
        if (config_result) {
            // 所在的区域
            if (regionList.indexOf(config_result['region']) > -1) {
                extendConfig['region'] = config_result['region'];
            }
            // 文件路径名称
            extendConfig['jsonFile'] = config_result['jsonFile'] || '';
            // 库phamula_id
            extendConfig['libraryId'] = config_result['libraryId'] || '';
            // 添加其它属性
            for (let key of Object.keys(config_result)) {
                if (['domainOrigin', 'region', 'jsonFile', 'libraryId'].indexOf(key) === -1) {
                    extendConfig[key] = config_result[key];
                }
            }
        }
        // 输入默认配置
        else {
            // 如果存在路由参数就解析路由参数
            if (SEARCH && QUERY['p_id']) {
                /*
                    ?p_id=      没有参数
                    ?p_id=1     库phamula_id为1
                    ?p_id=xito  文件路径名称为xito.o
                */
                if (isNaN(QUERY['p_id']) === false && Number(QUERY['p_id']) > 0) {
                    extendConfig['libraryId'] = QUERY['p_id'] || '';
                }
                // 否则就是文件路径名称
                else {
                    extendConfig['jsonFile'] = QUERY['p_id'] + '.o';
                }
            }
            // 默认phamula_id
            if (Boolean(extendConfig['jsonFile']) === false && Boolean(extendConfig['libraryId']) === false) {
                extendConfig['jsonFile'] = extendConfig['jsonFile'] || XITO_JSON_FILE;
                extendConfig['libraryId'] = extendConfig['libraryId'] || XITO_LIBRARY_ID;
            }
            extendConfig['needLogin'] = XITO_NEED_LOGIN;
        }
        
        // 集合所有的配置数据
        extendConfig['APP_ID'] = APP_ID;
        extendConfig['STRIPE_KEY'] = STRIPE_KEY;
        extendConfig['API'] = extendConfig['region'] === 'west' ? WEST_API : EAST_API;
        extendConfig['ACCESS_TOKEN'] = extendConfig['region'] === 'west' ? WEST_ACCESS_TOKEN : EAST_ACCESS_TOKEN;
        
        extendConfig['SESSION_KEY'] = SESSION_KEY;
        extendConfig['VERIFY_MOBILE'] = VERIFY_MOBILE;
        
        /****** 拓展配置 ******/
        for (let [ key, value ] of Object.entries(extendConfig)) {
            this[ key ] = value;
        }
    }
}

MyConfig.SESSION_KEY = SESSION_KEY;

MyConfig.install = function(Vue) {
    Vue.prototype.$config = new MyConfig;
}

export default MyConfig

// // main.js
// import config from './config/index.js'
// Vue.use(config)
// Vue.prototype.$config.extendConfig().then(_config => {
//     // do other things...
//     // 实例化Vue
//     new Vue({
//     	router,
//     	render: h => h(App)
//     }).$mount('#app')
// });

// // App.vue
// async beforeCreate() {
//     await this.$config.extendConfig();
// }

// // xxx.vue
// watch: {
//     '$route': {
//         async handler(newValue) {
//             await this.$config.extendConfig();
//             // do next thing...
//         },
//         immediate: true,
//         deep: true
//     }
// }